import { get } from 'lodash-es';

export const getUserProfile = (data) => {
  const employeeProfile = get(data, 'myEmployeeProfile');
  const companyDetails = get(data, 'myEmployeeProfile.company');
  const companyDocuments = get(data, 'companySettings.companyDocuments');
  const companyBankAccounts = get(data, 'companyBankAccounts');

  return {
    ksuid: get(employeeProfile, 'ksuid') as string || '',
    name: get(employeeProfile, 'name') as string || '',
    email: get(employeeProfile, 'user.email') as string || '',
    phoneNumber: get(employeeProfile, 'user.phoneNumber') as string || '',
    defaultLocale: get(employeeProfile, 'user.defaultLocale'),
    company: {
      accessType: get(employeeProfile, 'accessType', ''),
      accessTypes: get(employeeProfile, 'accessTypes', []) as string[],
      signatureName: get(companyDetails, 'signatureName', ''),
      signatureTitle: get(companyDetails, 'signatureTitle', ''),
      address: get(companyDetails, 'address') as string || '',
      email: get(companyDetails, 'email') as string || '',
      handle: get(companyDetails, 'handle'),
      hasConsentedCustomer: Boolean(get(companyDetails, 'hasConsentedCustomer')),
      isPartneredWithEnterpriseShipper: get(companyDetails, 'isPartneredWithEnterpriseShipper'),
      isDofEligible: Boolean(get(companyDetails, 'isDofEligible')),
      isPodfEligible: Boolean(get(companyDetails, 'isPodfEligible')),
      ksuid: get(companyDetails, 'ksuid') as string,
      logo: {
        url: get(companyDetails, 'logo.url.full'),
        fileName: get(companyDetails, 'logo.fileName') as string || '',
      },
      metadata: get(companyDetails, 'metadata') as string || '',
      name: get(data, 'companySettings.companyDetails.name') as string || '',
      phoneNumber: get(companyDetails, 'phoneNumber') as string || '',
      status: get(companyDetails, 'status'),
      type: get(companyDetails, 'type'),
      documents: {
        ktp: {
          url: get(companyDocuments, 'ktpFile.url.full'),
          fileName: get(companyDocuments, 'ktpFile.fileName') as string || '',
          uploadedAt: get(companyDocuments, 'ktpFile.uploadedAt.datetime'),
        },
        npwp: {
          url: get(companyDocuments, 'npwpFile.url.full'),
          fileName: get(companyDocuments, 'npwpFile.fileName') as string || '',
          uploadedAt: get(companyDocuments, 'npwpFile.uploadedAt.datetime'),
        },
        sppkp: {
          url: get(companyDocuments, 'sppkpFile.url.full'),
          fileName: get(companyDocuments, 'sppkpFile.fileName') as string || '',
          uploadedAt: get(companyDocuments, 'sppkpFile.uploadedAt.datetime'),
        },
      },
    },
    bankAccounts: Array.isArray(companyBankAccounts)
      ? companyBankAccounts.map((account) => ({
        ksuid: get(account, 'ksuid'),
        accountHolder: get(account, 'accountHolder'),
        accountNumber: get(account, 'accountNumber'),
        isDefault: get(account, 'isDefault'),
        bank: {
          ksuid: get(account, 'bank.ksuid'),
          name: get(account, 'bank.name'),
        },
      }))
      : [],
  };
};

export default getUserProfile;
